import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projects: [
    {
      id: 1,
      name: 'Artist Next Door',
      description: "India's first full-stack artist marketplace serving 4,000+ creators across 372 cities",
      url: 'https://artistnextdoor.in',
      image: '/assets/and.png',
      tech: ['React', 'Node.js', 'AWS', 'MongoDB'],
      category: 'web',
      featured: true,
    },
    {
      id: 2,
      name: 'ZaziDating',
      description: 'Modern dating app with advanced matching algorithms and real-time chat features',
      url: 'https://play.google.com/store/apps/details?id=com.zazidating',
      image: '/assets/zazi.png',
      tech: ['React Native', 'Java Spring Boot', 'ArangoDB', 'WebSocket'],
      category: 'mobile',
      featured: true,
    },
    {
      id: 3,
      name: 'Palmistry AI',
      description: 'AI-powered palm reading app with computer vision and subscription monetization',
      url: 'https://play.google.com/store/apps/details?id=com.palmaionline.palmistry',
      image: '/assets/palmistry.png',
      tech: ['React Native', 'AI/ML', 'Computer Vision', 'Razorpay'],
      category: 'mobile',
      featured: true,
    },
    {
      id: 4,
      name: 'Artist Next Door App',
      description: 'Mobile companion app for the artist marketplace platform',
      url: 'https://play.google.com/store/apps/details?id=com.artistnextdoor.and',
      image: '/assets/and-app.png',
      tech: ['React Native', 'Firebase', 'Push Notifications'],
      category: 'mobile',
      featured: false,
    },
    {
      id: 5,
      name: 'Guru Ganesh Saree',
      description: 'E-commerce platform for traditional Indian sarees with payment integration',
      url: 'https://guruganeshsaree.com/',
      image: '/assets/saree.png',
      tech: ['React', 'Node.js', 'Payment Gateway', 'MongoDB'],
      category: 'web',
      featured: false,
    },
    {
      id: 6,
      name: 'Tech Jupyter',
      description: 'Tech blog and educational platform',
      url: 'https://techjupyter.com',
      image: '/assets/jupyter.png',
      tech: ['React', 'Next.js', 'SEO', 'CMS'],
      category: 'web',
      featured: false,
    },
  ],
  services: [
    {
      id: 1,
      title: 'Mobile App Development',
      description: 'Native & Cross-platform mobile applications with React Native, Flutter & Swift',
      icon: '📱',
    },
    {
      id: 2,
      title: 'Web Development',
      description: 'Full-stack web applications using React, Next.js, Node.js & modern frameworks',
      icon: '💻',
    },
    {
      id: 3,
      title: 'AI & Machine Learning',
      description: 'AI-powered solutions, computer vision, NLP & intelligent automation',
      icon: '🤖',
    },
    {
      id: 4,
      title: 'Cloud & DevOps',
      description: 'AWS, Azure deployment, CI/CD pipelines & scalable infrastructure',
      icon: '☁️',
    },
    {
      id: 5,
      title: 'Database Architecture',
      description: 'SQL & NoSQL database design, optimization & performance tuning',
      icon: '🗄️',
    },
    {
      id: 6,
      title: 'Payment Integration',
      description: 'Razorpay, Stripe & custom payment gateway implementations',
      icon: '💳',
    },
  ],
  techStack: {
    frontend: ['React', 'Next.js', 'React Native', 'Flutter', 'Redux', 'TypeScript', 'Tailwind CSS'],
    backend: ['Node.js', 'Java Spring Boot', 'Express', 'WebSocket', 'Microservices'],
    database: ['MongoDB', 'ArangoDB', 'PostgreSQL', 'Redis', 'Firebase'],
    cloud: ['AWS', 'Azure', 'Docker', 'Kubernetes', 'CI/CD'],
    tools: ['Git', 'Jira', 'Figma', 'Postman', 'Jest'],
  },
  selectedCategory: 'all',
};

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {
    setCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    addProject: (state, action) => {
      state.projects.push(action.payload);
    },
  },
});

export const { setCategory, addProject } = portfolioSlice.actions;
export default portfolioSlice.reducer;
